import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import SuccessMsg from "../../Messages/SuccessMsg";
import { InstructionInterface, DefaultInstructionInterface, ShowInstructionContext } from "./types";
import { getInstructionsApi } from "../../redux/instruction/instructionApiCalls";
import EditInstruction from "./EditInstruction";
import DeleteInstruction from "./DeleteInstruction";
import AddNewInstruction from "./AddNewInstruction";
import DataInstructions from "./DataInstructions";

const ShowInstructions = () => {
  const [showSuccessMsg, setShowSuccessMsg] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedInstruction, setSelectedInstruction] = useState<InstructionInterface>(DefaultInstructionInterface);

  const dispatch: any = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(getInstructionsApi());
    };
    fetchData();
  }, [dispatch]);


  return (
    <ShowInstructionContext.Provider value={{
      showSuccessMsg, setShowSuccessMsg,
      showEditModal, setShowEditModal,
      showDeleteModal, setShowDeleteModal,
      selectedInstruction, setSelectedInstruction,
    }}>
      {showSuccessMsg && (
        <SuccessMsg
          modal={showSuccessMsg}
          toggle={() => setShowSuccessMsg(!showSuccessMsg)}
        />
      )}
      
      <AddNewInstruction />
      <DataInstructions />
      {showEditModal && 
        <EditInstruction 
          modal={showEditModal}
          toggle={() => setShowEditModal(!showEditModal)}
          selectedInstruction={selectedInstruction} 
        />}
      {showDeleteModal && 
        <DeleteInstruction 
          modal={showDeleteModal}
          toggle={() => setShowDeleteModal(!showDeleteModal)}
          selectedInstruction={selectedInstruction} 
        />
      }

    </ShowInstructionContext.Provider>
  );
};

export default ShowInstructions;
